export const ageMethod = "age nearest";
export const gateway = "https://sterling-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/sterling";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJzdGVybGluZyIsIm5hbWUiOiJzdGVybGluZyIsImlhdCI6MTc3OTkyNjYwMywiZXhwIjoxOTM3NzE0NjAzfQ.-p7jzHGOFVHE8xBDwU69LJchS-3_DVBBpBwFT_yWZuE";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"sterling.link.wawanesalife.com": {
		a: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_sterling",
			brands: [
				"sterling.link.wawanesalife.com",
			],
			broker: "sterling",
			broker_formatted_name: "Sterling Brokers",
			email: "info@sterlingbrokers.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-BKLFX8DNNL",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"48-209 Wicksteed Avenue",
				"Toronto",
				"ON",
				"M4G 0B1",
			],
			map2: [
				"Suite 200 84 Chain Lake Drive",
				"Halifax",
				"NS",
				"B3S 1A2",
			],
			map3: [
				"Suite 1501 1111 West Georgia St.",
				"Vancouver",
				"BC",
				"V6E 4M3",
			],
			map4: [
				"Unit 110 4919-59 Street",
				"Red Deer",
				"AB",
				"T4P 1M8",
			],
			"maps": {
				"map4": [
					"Unit 110 4919-59 Street",
					"Red Deer",
					"AB",
					"T4P 1M8",
				],
				"map3": [
					"Suite 1501 1111 West Georgia St.",
					"Vancouver",
					"BC",
					"V6E 4M3",
				],
				"map2": [
					"Suite 200 84 Chain Lake Drive",
					"Halifax",
					"NS",
					"B3S 1A2",
				],
				"map1": [
					"48-209 Wicksteed Avenue",
					"Toronto",
					"ON",
					"M4G 0B1",
				],
			},
			menuPhone: "button",
			phone: "1-888-213-5557",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.iubenda.com/privacy-policy/90666380/full-legal",
			tagline: "Modern Benefit Solutions for Canadian Businesses",
			themeSwitcher: "hide",
			website: "https://www.sterlingbrokers.com/",
			scope: "sterling#branding#sterling.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "sterling.link.wawanesalife.com",
		},
		b: {
			approve_company: "EAST ONTARIO",
			approve_user: "link_sterling",
			brands: [
				"sterling.link.wawanesalife.com",
			],
			broker: "sterling",
			broker_formatted_name: "Sterling Brokers",
			email: "info@sterlingbrokers.com",
			environment: "stable",
			environment_id: "stable",
			g4: "G-BKLFX8DNNL",
			layout: "modern",
			logoPosition: "menu",
			map1: [
				"48-209 Wicksteed Avenue",
				"Toronto",
				"ON",
				"M4G 0B1",
			],
			map2: [
				"Suite 200 84 Chain Lake Drive",
				"Halifax",
				"NS",
				"B3S 1A2",
			],
			map3: [
				"Suite 1501 1111 West Georgia St.",
				"Vancouver",
				"BC",
				"V6E 4M3",
			],
			map4: [
				"Unit 110 4919-59 Street",
				"Red Deer",
				"AB",
				"T4P 1M8",
			],
			"maps": {
				"map4": [
					"Unit 110 4919-59 Street",
					"Red Deer",
					"AB",
					"T4P 1M8",
				],
				"map3": [
					"Suite 1501 1111 West Georgia St.",
					"Vancouver",
					"BC",
					"V6E 4M3",
				],
				"map2": [
					"Suite 200 84 Chain Lake Drive",
					"Halifax",
					"NS",
					"B3S 1A2",
				],
				"map1": [
					"48-209 Wicksteed Avenue",
					"Toronto",
					"ON",
					"M4G 0B1",
				],
			},
			menuPhone: "button",
			phone: "1-888-213-5557",
			photo1: "hide",
			photo2: "hide",
			photo3: "hide",
			photo4: "hide",
			privacyLink: "https://www.iubenda.com/privacy-policy/90666380/full-legal",
			tagline: "Modern Benefit Solutions for Canadian Businesses",
			themeSwitcher: "hide",
			website: "https://www.sterlingbrokers.com/",
			scope: "sterling#branding#sterling.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "sterling.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 19:03:23 GMT-0500 (Central Daylight Time)
